import { FaArrowRight } from "react-icons/fa";
import { certifications } from "../data";
import SectionHeading from "./SectionHeading";

const tones = ["pink", "blue", "lilac", "peach", "pink"];

function Certifications() {
  return (
    <section className="section container" id="certifications">
      <SectionHeading title="Certifications" />

      <div className="rows">
        {certifications.map((cert, index) => (
          <a
            className={`row row-link hover-${tones[index % tones.length]}`}
            href={cert.url}
            target="_blank"
            rel="noopener noreferrer"
            key={cert.title}
          >
            <span className="mono">{cert.issuer}</span>
            <div>
              <h3>{cert.title}</h3>
              <p className="row-text">{cert.text}</p>
            </div>
            <span className="row-cta">
              Verify <FaArrowRight />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default Certifications;
